import React, { useState, useEffect } from "react";
import "./Carousel.css";

const Carousel = () => {
  const images = Array.from({ length: 37 }, (_, i) => `/images/${i + 1}.png`);

  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 6; // number of images visible at once

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // change every 3s
    return () => clearInterval(interval);
  }, [images.length]);

  const getVisibleImages = () => {
    const result = [];
    for (let i = 0; i < visibleCount; i++) {
      result.push(images[(currentIndex + i) % images.length]);
    }
    return result;
  };

  return (
    <div className="multi-slideshow">
      {getVisibleImages().map((src, idx) => (
        <img
          key={idx}
          src={src}
          alt={`Slide ${currentIndex + idx + 1}`}
          className="multi-slide"
        />
      ))}
    </div>
  );
};

export default Carousel;